<template>
  <div class="col-12">
    <div class="card">
      <div class="card-body">
        <div class="d-flex title">
          <div>
            <h3 class="card-title"><i class="ti-user"></i> {{ $t('Attendees') }}</h3></div>
          <div class="ml-auto">
            <button v-on:click="addUser" type="button" class="btn btn-sm btn-rounded btn-info"><i class="ti-plus"></i> {{ $t('Add attendee') }}</button>
          </div>
        </div>
        <div class="table-responsive m-t-20">
          <table class="table vm no-th-brd pro-of-month">
            <tbody>
            <tr v-for="(attendee, index) in attendee_data">
              <td style="width:50px;">
                <toggle-button id="disable-it" :value="attendee.present" v-model.lazy="attendee.present" @change="updatePresence()"></toggle-button>
              </td>
              <td class="user-photo" style="width:50px;">
                <span class="round">
                  <!-- TODO: Remove test.achiev.eu-->
                  <img :src="attendee.photo" alt="user" width="50" height="50">
                </span>
              </td>
              <td>
                <h6>{{ attendee.firstname }} {{ attendee.lastname }}</h6>
                <small class="user-title text-muted">{{ attendee.Units | unitFormatter }}</small>
              </td>
              <td>
                <div v-if="!attendee.in_norm">
                <a @click="removeAttendee(attendee.meeting_user_id, index)">{{ $t('Remove') }}</a>
                </div>
              </td>
            </tr>
            </tbody>
          </table>
        </div>

        <div v-if="add_user" class="row">
          <div class="col-sm-12 col-xs-12">
            <div class="m-t-20">
              <div class="form-group row">
                <label for="action-title" class="col-sm-12 control-label">{{ $t('Invite other attendees') }}</label>
              </div>
              <div class="form-group row">
                <div class="col-sm-8">
                  <div class="input-group">
                    <select v-model="selectedUser" id="action-title" class="form-control btn-rounded action-owner">
                      <option v-if="user_data.length === 0" value="0" selected="true" disabled="disabled">{{ $t('All users are in the meeting') }}</option>
                      <option v-else selected="true" value="0" disabled="disabled">{{ $t('Select a collegue') }}</option>
                      <option v-for="user in user_data" :value="user">{{ user.firstname }} {{ user.lastname }}</option>
                    </select>
                  </div>
                </div>
                <div class="col-sm-4">
                  <button class="btn btn-sm btn-rounded btn-info" v-on:click="addAttendee" :disabled="selectedUser === 0"><i class="ti-plus"></i> {{ $t('Add') }}</button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import apiHelper from '../mixins/APIHelper';

  export default {
    name: "attendees-widget",
    props: {
      'attendees' : {
        default: []
      },

      'meeting_uid' : {
        default: 0
      }
    },
    data: function () {
      return {
        meeting: this.meeting_uid,
        user_data: [],
        attendee_data: [],
        selectedUser: 0,
        add_user: false
      }
    },
    created() {
      this.attendee_data = JSON.parse(JSON.stringify(this.attendees));
      this.getAllUsers();
    },
    methods: {
      // Grabs all the users
      getAllUsers: function () {
        let vm = this;
        apiHelper.getResource("/api/user").then((data) => {
          vm.user_data = data.data;
          vm.filterUsers();
        });
      },

      // Filters the users that are already in the meeting so that they don't appear twice
      filterUsers: function () {
        let vm = this;
        let att_list = [];
        let nonDuplicateUsers = [];

        for (let i = 0; i < vm.attendee_data.length; i++) {
          att_list.push(vm.attendee_data[i].uid);
        }

        for (let i = 0; i < vm.user_data.length; i++) {
          if(att_list.indexOf(vm.user_data[i].uid) === -1){
            nonDuplicateUsers.push(vm.user_data[i]);
          }
        }

        vm.user_data = nonDuplicateUsers;
      },

      // Adds an attendee to the meeting
      addAttendee: function () {
        let vm = this;
        let data_to_send = {
          "user_uid": vm.selectedUser.uid,
          "present": 1
        };

        apiHelper.postResource("/api/meeting/" + vm.meeting + "/invitee", data_to_send).then((data) => {
            vm.attendee_data.push(data);

            let index = vm.user_data.indexOf(vm.selectedUser);
            vm.user_data.splice(index, 1);
            vm.selectedUser = 0;
        });
      },

      // Removes an added attendee from the meeting
      removeAttendee: function (id, index) {
        let vm = this;

        apiHelper.delResource("/api/meeting/" + vm.meeting + "/invitee/" + id).then((data) => {
          if (data === 1) {
            vm.attendee_data.splice(index, 1);
            vm.getAllUsers();
          }
        })
      },

      // Function to make you add a user
      addUser: function () {
        this.add_user = !this.add_user;
      },

      // Update the presence of a user
      updatePresence: function() {
        let vm = this;
        let attendees = {};

        for (let i = 0; i < vm.attendee_data.length; i++) {
          attendees[vm.attendee_data[i]["uid"]] = vm.attendee_data[i]["present"];
        }

        let data_to_send = {
          attendees
        };

        apiHelper.putResource("/api/meeting/" + vm.meeting_uid + "/attendee", data_to_send).then((data) => {
        });
      }
    },
    computed: {
      // Find the height for the scrollbox of the actions
      findHeight: function () {
        if (this.attendee_data.length > 2) {
          return "overflow-y: scroll; height: 240px;"
        } else {
          let h = String(this.attendee_data.length * 80);
          return "overflow-y: hidden; height: " + h + "px;";
        }
      }
    },
    beforeDestroy: function () {
      let vm = this;
      vm.$parent.meeting_users = vm.attendee_data.filter(attendee => attendee.present);
      vm.$parent.meeting_attendees = vm.attendee_data;
    }
  };
</script>

<style scoped>
  .title {
    display: flex !important;
  }

  @media screen and (max-width: 550px){
    .title {
      display: block !important;
    }

    .user-photo {
      display: none;
    }

    .user-title {
      display: none;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/AttendeesWidget.vue